import { httpWithAuth } from '~/clients';
import { getToggleCoApplicant } from '~/constants/endpoints';

export default function toggleCoApplicant(userId: string) {
  return httpWithAuth.post<{ coApplicantToggleOn: boolean }>(
    getToggleCoApplicant(userId)
  );
}
